import { Trash2 } from "lucide-react";
import React from "react";

import { IgGrayPrimitives } from "@intelligems/ig-design-tokens";
import {
  IgAutocomplete,
  IgIconButton,
  IgTextField,
  IgTypography,
} from "@intelligems/ig-theme";
import { SimpleCollection } from "@intelligems/ig-types";
import { Stack } from "@mui/material";
import Grid from "@mui/material/Grid";
import { theme } from "@src/theme";

interface CollectionListItemProps {
  selectedCollection: SimpleCollection | null;
  selectedCollections: (SimpleCollection | null)[];
  options: SimpleCollection[];
  isArchived: boolean;
  onChange: (newValue: SimpleCollection | null) => void;
  onRemove: () => void;
}

export const CollectionListItem = ({
  selectedCollection,
  options,
  isArchived,
  onChange,
  onRemove,
  selectedCollections,
}: CollectionListItemProps) => {
  return (
    <Grid
      container
      direction={"row"}
      width={"100%"}
      alignItems={"center"}
      wrap={"nowrap"}
      sx={{ "&:hover .trash-can": { opacity: 1 } }}
    >
      <Grid
        container
        direction={"row"}
        wrap={"nowrap"}
        alignItems={"center"}
        marginBottom={"15px"}
        size={12}
        sx={{
          "&:hover .trash-can": {
            opacity: 1,
          },
        }}
      >
        <IgAutocomplete
          disablePortal
          onChange={(e, newValue) => onChange(newValue)}
          isOptionEqualToValue={(option, value) => {
            return option.handle === value?.handle;
          }}
          options={options}
          value={selectedCollection}
          disabled={isArchived}
          sx={{
            "& .Mui-disabled": {
              backgroundColor: IgGrayPrimitives[300],
            },
            marginRight: "10px",
          }}
          disableClearable
          fullWidth
          getOptionLabel={(option) => option.title}
          getOptionDisabled={(option) => {
            return selectedCollections.some(
              (selected) => selected?.handle === option.handle
            );
          }}
          filterOptions={(options, { inputValue }) => {
            const filterValue = inputValue.toLowerCase();
            return options.filter(
              (option) =>
                option.title.toLowerCase().includes(filterValue) ||
                (option.id &&
                  option.id.toString().toLowerCase().includes(filterValue))
            );
          }}
          renderInput={(params) => (
            <Stack spacing={1}>
              <IgTypography>Select a Collection</IgTypography>
              <Stack flexDirection="row">
                <IgTextField {...params} />
                {!isArchived && (
                  <IgIconButton onClick={onRemove}>
                    <Trash2
                      size={18}
                      className="trash-can"
                      color={theme.igIconColors.error}
                    />
                  </IgIconButton>
                )}
              </Stack>
            </Stack>
          )}
          renderOption={(props, option) => (
            <li {...props} key={option.handle}>
              <Grid
                container
                direction={"row"}
                alignContent={"center"}
                columnSpacing={2}
              >
                <Grid>
                  <IgTypography>{option.title}</IgTypography>
                </Grid>
                <Grid>
                  <IgTypography color={theme.palette.text.secondary}>
                    {option.description || "No description available"}
                  </IgTypography>
                </Grid>
              </Grid>
            </li>
          )}
        />
      </Grid>
    </Grid>
  );
};
